import IPlugin from "./plugin";
import PluginError from "../errors/plugin.error";
import RepositoryManager from "../repositories";

const ERROR_NO_STORE = 'Please add store to the Vue config before using Repositories plugin.';

export default class RepositoriesPlugin extends IPlugin {
    setup(Vue, config) {
        if (!config.store) {
            throw new PluginError(this, ERROR_NO_STORE);
        }
        RepositoryManager.setStore(config.store);
        config.repositories = RepositoryManager;
        Vue.mixin({
            beforeCreate() {
                /**
                 * !!!! IMPORTANT !!!
                 * We DO OVERRIDE vuex $store.
                 * Any access to state should
                 * be via repository
                 */
                this.$store = RepositoryManager;
            }
        });
        return super.setup(Vue, config);
    }
}